export default __webpack_public_path__ + "static/kyuho.lee-1b2a3c09a154dd84b3195ce6e15f3d55.jpeg";